import React from 'react';

const FormFieldIcon = ({ icon: Icon, size = 20 }) => (
  <Icon size={size} strokeWidth={1.75} color="var(--text-color-50)" aria-hidden />
);

export default FormFieldIcon;
